export default __webpack_public_path__ + "static/media/undraw_Mail_re_duel.10f94b62.svg";